import React, { useContext, useState } from "react";
import { Row, Col } from "antd";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import { loadAuth2, loadAuth2WithProps, loadClientAuth2 } from "gapi-script";
import nsLogo from "./netskope-logo-white.svg";
import styles from "./GoogleLogger.module.css";
import { UserContext } from "../Reducers/UserContext";
import { fetchUserVal, fetchJwtToken } from "../../api";
import { UI_ENV } from '../../config/env';
const envs = require('../../env.json');

const GoogleLogger = () => {
    const { isLoggedIn, setLogger } = useContext(UserContext);
    const [isFadeOut, setFadeOut] = useState(false);

    // useEffect(() => {
    // console.log("hey ya");
    // const initClient = () => {
    //   gapi.auth2.init({
    //     clientId: envs[env]["client"],
    //     scope: "",
    //   });
    // };
    // gapi.load("client:auth2", initClient);
    // });

    // let gapiClient = loadClientAuth2(gapi, envs[env]["client"], "");
    let auth2 = loadAuth2(gapi, envs[UI_ENV]['client'], '');

    let rold;
    const responseGoogle = async (response) => {
        if (!response.profileObj) return;
        if (response.profileObj.name) {
            await fetchJwtToken(response.tokenId);
            const { data } = await fetchUserVal('checkUser', {
                firstVal: response.profileObj.googleId,
                secondVal: response.profileObj.imageUrl,
                thirdVal: response.profileObj.name,
                fourthVal: response.profileObj.email,
            });
            // console.log("obtained data is ", data[1]);
            if (data[1]['affectedRows'] == 0) {
                console.log('Login api data - ', data);
                rold = 'Guest';
                // localStorage.setItem("role", "Guest");
            } else {
                console.log('assigned role', data[0][0]['role']);
                // localStorage.setItem("role", data[0][0]["role"]);
                rold = data[0][0]['role'];
            }
            setLogger({
                active: !isLoggedIn['active'],
                user: {
                    name: response.profileObj.name,
                    imgUrl: response.profileObj.imageUrl,
                    role: rold,
                    email: response.profileObj.email,
                },
            });
        }
    };

    return (
        <div>
            <div>
                {!isLoggedIn['active'] ? (
                    <div>
                        <div className={styles.dark_page_background} style={{ zIndex: '-1' }}>
                            <div className={styles.container} style={{ maxWidth: '100%' }}>
                                <div className={styles.sliding_background}></div>
                                <div className={styles.foreground}></div>
                                <div className={styles.overlay + (isFadeOut ? ' ' + styles.fade_out : '')}></div>
                            </div>
                        </div>
                        <Row>
                            <Col span={24}>
                                <div className={styles.ns_login_outer}>
                                    <img src='/img/netskope-logo-white.svg' alt='' width='300px' height='62x' />
                                    <div
                                        id='reimagine_link'
                                        className={styles.ns_txt_link + (isFadeOut ? ' ' + styles.fade_out : '')}
                                        onClick={() => {
                                            setFadeOut(true);
                                        }}
                                        style={{ marginBottom: '1.5rem', cursor: 'pointer' }}
                                    >
                                        <i className={styles.netskope_icon_stars}></i>Reimagine Your Perimeter
                                    </div>
                                    <div className={styles.ns_login_wrapper}>
                                        <div className={styles.ns_logo_container}>
                                            <div className={styles.shooting_star + (isFadeOut ? ' ' + styles.animate : '')}></div>
                                        </div>
                                    </div>
                                    <h5 style={{ color: 'red' }}></h5>
                                    <GoogleLogin
                                        clientId={envs[UI_ENV]['client']}
                                        render={(renderProps) => (
                                            <a>
                                                <img style={{ width: '50%' }} onClick={renderProps.onClick} src='img/google_signin.png' />
                                            </a>
                                        )}
                                        buttonText='Login'
                                        onSuccess={responseGoogle}
                                        onFailure={responseGoogle}
                                        cookiePolicy={'single_host_origin'}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default GoogleLogger;
